// 통합 패키지 내부의 Hook과 타입들을 export
export { useDebugTimeMachine } from './useDebugTimeMachine';

export type {
  IDebugTimeMachineConfig,
  IDebugTimeMachineHookReturn,
  IConnectionInfo,
  IUserActionData,
  IStateChangeData,
  IErrorData,
  IConnectionData,
  TConnectionType,
  IMessage,
} from './types';

export { MessageType } from './types';
